import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { Link } from 'react-router-dom';
export function ReadyToCookPage() {
  return <div className="bg-white" data-id="element-706">
      <PageHero title="Ready-to-Cook" subtitle="Premium marinated meats and prepared ingredients to elevate your home cooking experience." backgroundImage="https://images.unsplash.com/photo-1466637574441-749b8f19452f?w=1920&q=80" data-id="element-707" />

      <section className="py-24 md:py-32" data-id="element-708">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-709">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-32" data-id="element-710">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-711">
              <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-712">
                Restaurant Quality, At Home
              </h2>
              <div className="w-16 h-1 bg-brand-terracotta mb-8" data-id="element-713"></div>
              <p className="text-lg text-brand-dark/80 font-light leading-relaxed mb-8" data-id="element-714">
                Bring the signature flavors of JJ Group into your own kitchen.
                Our Ready-to-Cook line features the exact same premium cuts of
                meat, house-made marinades, and spice blends used by our
                executive chefs.
              </p>
              <ul className="space-y-4 mb-10" data-id="element-715">
                {['Premium sourced proteins', 'Chef-crafted marinades', 'Vacuum sealed for freshness', 'Step-by-step cooking instructions'].map((item, i) => <li key={i} className="flex items-center gap-3 text-brand-dark/70" data-id="element-716">
                    <div className="w-1.5 h-1.5 bg-brand-red rounded-full" data-id="element-717"></div>
                    {item}
                  </li>)}
              </ul>
              <Link to="/company/contact" className="inline-block bg-brand-dark text-white px-8 py-4 text-sm uppercase tracking-[0.2em] hover:bg-brand-red transition-colors" data-id="element-718">
                Order Online
              </Link>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-719">
              <img src="https://images.unsplash.com/photo-1607116176195-b81b1f41f536?w=800&q=80" alt="Raw premium meat" className="w-full h-[600px] object-cover rounded-sm shadow-2xl" data-id="element-720" />
            </motion.div>
          </div>

          <div className="text-center mb-16" data-id="element-721">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-dark mb-6" data-id="element-722">
              How It Works
            </h2>
            <div className="w-16 h-1 bg-brand-gold mx-auto" data-id="element-723"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-724">
            {[{
            step: '01',
            title: 'Order Online',
            desc: 'Select from our curated menu of marinated meats, sides, and signature sauces.'
          }, {
            step: '02',
            title: 'Pick Up or Delivery',
            desc: 'Collect your order from any JJ Express location or choose refrigerated delivery.'
          }, {
            step: '03',
            title: 'Cook & Enjoy',
            desc: 'Follow the simple chef instructions to prepare a flawless meal at home.'
          }].map((item, idx) => <motion.div key={idx} className="text-center p-8 border border-brand-dark/10 rounded-sm" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} data-id="element-725">
                <div className="text-5xl font-serif text-brand-dark/10 font-bold mb-4" data-id="element-726">
                  {item.step}
                </div>
                <h3 className="text-2xl font-serif text-brand-dark mb-4" data-id="element-727">
                  {item.title}
                </h3>
                <p className="text-brand-dark/70 font-light" data-id="element-728">{item.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}